/*
 * Cross-sell AJAX add for the cart drawer.
 * Delegated on document so it survives every drawer re-render. Adds via
 * /cart/add.js requesting the cart-drawer + cart-icon-bubble sections, then
 * hands the response to the existing cart-drawer element's renderContents() —
 * the same path product-form.js uses — so the drawer, totals, free-shipping bar
 * and bubble all refresh without a reload and without the third-party upsell
 * app. Fails quietly (button re-enables) on any error.
 *
 * Extracted from the inline <script> that previously shipped in every HTML
 * response from snippets/cart-drawer.liquid. Loaded deferred, so it runs after
 * parse; the __bbXsellBound guard keeps it single-bound even if re-evaluated.
 */
(function () {
  if (window.__bbXsellBound) return;
  window.__bbXsellBound = true;

  document.addEventListener('click', function (evt) {
    var btn = evt.target.closest('[data-bb-xsell-add]');
    if (!btn) return;
    evt.preventDefault();
    if (btn.getAttribute('aria-disabled') === 'true') return;

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    // Surface add-to-cart errors near the button. Clear any prior message so a
    // fresh attempt starts clean.
    var container = btn.closest('[data-bb-xsell]') || document;
    var errorEl = container.querySelector('[data-bb-xsell-error]');
    var localizedError =
      (container.getAttribute && container.getAttribute('data-bb-xsell-error-text')) ||
      (window.cartStrings && window.cartStrings.error) ||
      'There was an error adding this item.';
    var defaultError = localizedError;
    if (errorEl) errorEl.textContent = '';

    var drawer = document.querySelector('cart-drawer');
    var sections = ['cart-drawer', 'cart-icon-bubble'];
    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      try {
        sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      } catch (e) { /* fall back to defaults */ }
    }

    var labelEl = btn.querySelector('span');
    var prevLabel = labelEl ? labelEl.textContent : '';
    btn.setAttribute('aria-disabled', 'true');
    if (labelEl) labelEl.textContent = '…';

    var body = {
      items: [{ id: Number(variantId), quantity: 1 }],
      sections: sections,
      sections_url: window.location.pathname,
    };

    var addUrl = (window.routes && window.routes.cart_add_url) || '/cart/add';

    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) {
        // A 500/HTML error page won't be valid JSON — throw into the catch path
        // so the shopper still gets a message instead of a silent no-op.
        if (!r.ok) throw new Error('Cart add failed: ' + r.status);
        return r.json();
      })
      .then(function (response) {
        if (response.status) {
          // Shopify soft error (sold out / quantity limit): JSON carries a
          // `status` field plus a human-readable `description`. Show it.
          if (errorEl) errorEl.textContent = response.description || defaultError;
          return;
        }
        if (drawer && typeof drawer.renderContents === 'function') {
          drawer.renderContents(response);
          // Mirror product-form.js: notify Dawn's pubsub subscribers so the cart
          // icon bubble and any other listeners stay in sync. Guarded because
          // this script must not hard-depend on the bundle being present.
          // ORDERING CONTRACT: published AFTER renderContents so subscribers see
          // a settled DOM. `sectionsRendered: true` = the drawer sections in
          // this payload are already painted, so cart.js skips its redundant
          // re-fetch (audit F5).
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'bb-xsell',
              productVariantId: variantId,
              cartData: response,
              sectionsRendered: true,
            });
          }
        } else if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          // No drawer on this page — nothing was rendered, so no
          // sectionsRendered flag: subscribers must do their own re-fetch.
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'bb-xsell',
            productVariantId: variantId,
            cartData: response,
          });
        }
      })
      .catch(function () {
        // Network failure or non-OK response — show the generic error.
        if (errorEl) errorEl.textContent = defaultError;
      })
      .finally(function () {
        // Restore the button in every path. The drawer usually re-renders this
        // button away on success; restore it only if it survived in the DOM.
        if (document.body.contains(btn)) {
          btn.removeAttribute('aria-disabled');
          if (labelEl) labelEl.textContent = prevLabel;
        }
      });
  });
})();
